export default __webpack_public_path__ + "static/009-69036078cafbfde6ac28738ee770ee56.jpg";